import {call, put, takeEvery, takeLatest} from 'redux-saga/effects'
import {api} from '../utils/api';


function* processIndexBundle(action) {
  let {payload: {indexRecords, featuredRecords, updatedLives}} = action;

  yield put({
    type: 'FETCH_INDEXRECORDS_SUCCESSED',
    payload: indexRecords,

  });

  yield put({
    type: 'FETCH_FEATUREDRECORDS_SUCCESSED',
    payload: featuredRecords,
  });

  yield put({
    type: 'FETCH_UPDATEDLIVES_SUCCESSED',
    payload: updatedLives,
  });
}

function* processFetchObjects(action) {
  let {payload: {url, name, silent = false}} = action;
  // console.log('process fetch', name, url);

  if (!url || !name) {
    console.log('[error] invalid fetchObjects params, url:', url, 'name:', name);
    return;
  }

  try {
    if (!silent) {
      yield put({
        type: `FETCH_${name.toUpperCase()}`,
        payload: {...action.payload},
      });
    }

    // console.log('send request', name, url);
    const data = yield api('GET', url);

    if (silent) {
      yield put({
        type: `FETCH_${name.toUpperCase()}_SILENT`,
        payload: data,
      });

    } else {
      yield put({
        type: `FETCH_${name.toUpperCase()}_SUCCESSED`,
        payload: data,
      });
    }

  } catch (e) {
    console.log('error', e);
    yield put({
      type: `FETCH_${name.toUpperCase()}_FAILED`,
      payload: e,
    });
  }
}

function* fetchMoreCommentThreads(action) {
  let {url, thread} = action.payload;

  try {
    if (!url || !thread) {
      console.log('url or thread required', url, thread);
      return;
    }

    const data = yield api('GET', url);

    yield put({
      type: `FETCH_MORE_COMMENT_THREADS_SUCCESSED`,
      payload: {
        thread,
        data,
      },
    });
  } catch (e) {
    yield put({
      type: `FETCH_MORE_COMMENT_THREADS_FAILED`, payload: {
        thread,
        error: e,
      }
    });
  }
}

function* processFetchMoreObjects(action) {
  let {url, name} = action.payload;
  console.log('fetch more', name, url)

  try {
    if (!url || !name) {
      console.log('FETCH_MORE error', action.payload);
      return;
    }

    yield put({
      type: `FETCH_MORE_${name.toUpperCase()}`,
    });

    const data = yield api('GET', url);

    yield put({
      type: `FETCH_MORE_${name.toUpperCase()}_SUCCESSED`,
      payload: data,
    });

  } catch (e) {
    yield put({type: `FETCH_MORE_${name.toUpperCase()}_FAILED`, payload: e});
  }
}


function* mySaga() {
  yield takeEvery("FETCH_OBJECTS", processFetchObjects);
  yield takeEvery("FETCH_INDEXBUNDLE_SUCCESSED", processIndexBundle);
  yield takeEvery("FETCH_MORE_OBJECTS", processFetchMoreObjects);

  yield takeLatest("FETCH_MORE_COMMENT_THREADS", fetchMoreCommentThreads);
}

export default mySaga;

